import { ChangeDetectionStrategy, Component, inject, OnInit, viewChild, ViewContainerRef } from '@angular/core';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'spa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly vcr = viewChild.required('dynComp', { read: ViewContainerRef });

  private readonly notificationService = inject(NotificationService);

  ngOnInit() {
    this.notificationService.init(this.vcr());
  }
}
